import { put, select } from 'redux-saga/effects';
import { selectCallSessions, setCallSessions } from '../../../state/callSessions/callSessionsSlice';

export default function* sessionsUpdated() {
  const sessions = yield select(selectCallSessions);
  yield put(setCallSessions([...sessions]));
}
